import { BuildingModel, BuildingTypeModel, BuildingTypes } from "types";

import bishopPilotAcademyStaffImage from "assets/avatar-academy-bishop.svg";
import senecaPilotAcademyStaffImage from "assets/avatar-academy-seneca.svg";
import bishopJumpGateStaffImage from "assets/avatar-jump-gate-bishop.svg";
import senecaJumpGateStaffImage from "assets/avatar-jump-gate-seneca.svg";
import bishopShipworksStaffImage from "assets/avatar-shipworks-bishop.svg";
import senecaShipworksStaffImage from "assets/avatar-shipworks-seneca.svg";
import {
  default as bishopJumpGateInteriorImage,
  default as bishopPilotAcademyInteriorImage,
  default as bishopShipworksInteriorImage,
} from "assets/bg-shipworks-bishop.svg";
import {
  default as senecaJumpGateInteriorImage,
  default as senecaPilotAcademyInteriorImage,
  default as senecaShipworksInteriorImage,
} from "assets/bg-shipworks-seneca.png";
import bishopJumpGateExteriorImage from "assets/building-bishop-jump-gate.png";
import bishopPilotAcademyExteriorImage from "assets/building-bishop-pilot-academy.svg";
import bishopShipworksExteriorImage from "assets/building-bishop-shipworks.svg";
import bishopVectorStationExteriorImage from "assets/building-bishop-vector-station.svg";
import contraJumpGateExteriorImage from "assets/building-contra-jump-gate.png";
import contraPilotAcademyExteriorImage from "assets/building-contra-pilot-academy.png";
import contraShipworksExteriorImage from "assets/building-contra-shipworks.png";
import senecaJumpGateExteriorImage from "assets/building-seneca-jump-gate.png";
import senecaPilotAcademyExteriorImage from "assets/building-seneca-pilot-academy.png";
import senecaShipworksExteriorImage from "assets/building-seneca-shipworks.png";
import senecaVectorStationExteriorImage from "assets/building-seneca-vector-station.png";

interface BuildingData {
  [key: string]: BuildingModel;
}

export const BUILDINGS: BuildingData = {
  bishopShipworks: {
    type: "shipworks",
    name: "Bishop Loadout Hub",
    area: "bishopCity",
    position: 130,
    angle: "right",
    exteriorImage: bishopShipworksExteriorImage,
    interiorImage: bishopShipworksInteriorImage,
    staffImage: bishopShipworksStaffImage,
    staffName: "Starship Engineer Hollis",
  },
  bishopPilotAcademy: {
    type: "pilotAcademy",
    name: "Bishop Fleet Control",
    area: "bishopCity",
    position: 90,
    angle: "right",
    exteriorImage: bishopPilotAcademyExteriorImage,
    interiorImage: bishopPilotAcademyInteriorImage,
    staffImage: bishopPilotAcademyStaffImage,
    staffName: "Fleet Sergeant Conway",
  },
  bishopJumpGate: {
    type: "jumpGate",
    name: "Bishop Jump Gate",
    area: "bishopCity",
    position: 50,
    angle: "right",
    exteriorImage: bishopJumpGateExteriorImage,
    interiorImage: bishopJumpGateInteriorImage,
    staffImage: bishopJumpGateStaffImage,
    staffName: "Warp Operator Link",
  },
  bishopVectorStation: {
    type: "vectorStation",
    name: "Dash Port Loadout Bay",
    area: "dashPort",
    position: 60,
    angle: "right",
    exteriorImage: bishopVectorStationExteriorImage,
    interiorImage: bishopShipworksInteriorImage,
    staffImage: bishopShipworksStaffImage,
    staffName: "Rapid Tech Sinder",
  },
  senecaShipworks: {
    type: "shipworks",
    name: "Seneca Loadout Hub",
    area: "vale",
    position: 130,
    angle: "right",
    exteriorImage: senecaShipworksExteriorImage,
    interiorImage: senecaShipworksInteriorImage,
    staffImage: senecaShipworksStaffImage,
    staffName: "Starship Engineer Dice",
  },
  senecaPilotAcademy: {
    type: "pilotAcademy",
    name: "Seneca Fleet Control",
    area: "vale",
    position: 90,
    angle: "right",
    exteriorImage: senecaPilotAcademyExteriorImage,
    interiorImage: senecaPilotAcademyInteriorImage,
    staffImage: senecaPilotAcademyStaffImage,
    staffName: "Fleet Sergeant Arcera",
  },
  senecaJumpGate: {
    type: "jumpGate",
    name: "Seneca Jump Gate",
    area: "vale",
    position: 50,
    angle: "right",
    exteriorImage: senecaJumpGateExteriorImage,
    interiorImage: senecaJumpGateInteriorImage,
    staffImage: senecaJumpGateStaffImage,
    staffName: "Warp Operator Dash",
  },
  senecaVectorStation: {
    type: "vectorStation",
    name: "Horizon Loadout Bay",
    area: "core_horizon",
    position: 60,
    angle: "right",
    exteriorImage: senecaVectorStationExteriorImage,
    interiorImage: senecaShipworksInteriorImage,
    staffImage: senecaShipworksStaffImage,
    staffName: "Rapid Tech Gliden",
  },
  contraShipworks: {
    type: "shipworks",
    name: "Contra Loadout Hub",
    area: "skylock",
    position: 130,
    angle: "up",
    exteriorImage: contraShipworksExteriorImage,
    interiorImage: senecaShipworksInteriorImage,
    staffImage: senecaShipworksStaffImage,
    staffName: "Starship Engineer Gamble",
  },
  contraPilotAcademy: {
    type: "pilotAcademy",
    name: "Contra Fleet Control",
    area: "skylock",
    position: 90,
    angle: "up",
    exteriorImage: contraPilotAcademyExteriorImage,
    interiorImage: senecaPilotAcademyInteriorImage,
    staffImage: senecaPilotAcademyStaffImage,
    staffName: "Fleet Sergeant Deckard",
  },
  contraJumpGate: {
    type: "jumpGate",
    name: "Contra Jump Gate",
    area: "skylock",
    position: 50,
    angle: "up",
    exteriorImage: contraJumpGateExteriorImage,
    interiorImage: senecaJumpGateInteriorImage,
    staffImage: senecaJumpGateStaffImage,
    staffName: "Warp Operator Spade",
  },
};

export const BUILDING_TYPES: Record<BuildingTypes, BuildingTypeModel> = {
  shipworks: {
    name: "Loadout Hub",
    description: "Enhance stats and install upgrades for your ship.",
  },
  pilotAcademy: {
    name: "Fleet Control",
    description: "Train your pilot skills for use in battle.",
  },
  jumpGate: {
    name: "Jump Gate",
    description: "Travel to other planets.",
  },
  vectorStation: {
    name: "Loadout Bay",
    description: "Enhance stats and install upgrades for your ship.",
  },
};
